import { render, staticRenderFns } from "./PreferredFacilityModal.vue?vue&type=template&id=538d4182&scoped=true&"
import script from "./PreferredFacilityModal.vue?vue&type=script&lang=js&"
export * from "./PreferredFacilityModal.vue?vue&type=script&lang=js&"
import style0 from "./PreferredFacilityModal.vue?vue&type=style&index=0&id=538d4182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538d4182",
  null
  
)

export default component.exports